import React from "react";
import { finApi } from "@/lib/financeApi";
import { DetailShell, ErrorBox, Loading, useLoad } from "@/components/nds/windows/finance/parts";
import VendorProfileTab from "@/components/nds/windows/finance/VendorProfileTab";
import VendorInvoicesTab from "@/components/nds/windows/finance/VendorInvoicesTab";
import { LandlordEscrowTab, LandlordReimbursablesTab } from "@/components/nds/windows/finance/LandlordHistoryTabs";

const TABS = [
  { id: "profile", label: "Profile", Tab: VendorProfileTab, tone: "people", desc: "Contact, payment and tax details" },
  { id: "invoices", label: "Invoices", Tab: VendorInvoicesTab, tone: "financial", desc: "Every invoice from this vendor" },
];
const LANDLORD_TABS = [
  ...TABS,
  { id: "escrow", label: "Escrow", Tab: LandlordEscrowTab, tone: "data", desc: "Rent escrow held for this landlord" },
  { id: "reimbursables", label: "Reimbursables", Tab: LandlordReimbursablesTab, tone: "comms", desc: "Costs to be reimbursed to the landlord" },
];

export default function FinVendorDetail({ vendorId, onBack, onOpenInvoice }) {
  const [state, load] = useLoad(() => finApi.get(`/vendors/${vendorId}`), [vendorId]);
  if (state.loading && !state.data) return <Loading testid="fin-vendor-detail-loading" />;
  if (state.error) return <ErrorBox testid="fin-vendor-detail-error" error={state.error} onRetry={load} />;
  return <DetailShell prefix="fin-vendor" tabs={state.data.type === "landlord" ? LANDLORD_TABS : TABS} title={state.data.name} backLabel="All vendors" onBack={onBack}
    tabProps={{ vendor: state.data, reload: load, onOpenInvoice }} />;
}
